import { getAppCache } from '@retail/core';
import { addAccountImageBase64 } from '@shared/products-core';
import { getGeorgeByteImage } from '@shared/image';

import { getProductImage } from '../papi-migration/hooks/useProductImage';
import { isProductPapiCustomizationEnabled } from './isProductPapiCustomizationEnabled';

export const saveImageToCache = (accountId: string, image: string) => {
    const appCache = getAppCache();

    addAccountImageBase64({
        accountId,
        imageBase64: image,
    });

    appCache.set(`accountImage-${accountId}`, image);
};

export const removeImageFromCache = (accountId: string) => {
    const appCache = getAppCache();

    addAccountImageBase64({
        accountId,
        imageBase64: undefined,
    });

    appCache.remove(`accountImage-${accountId}`);
};

export const loadAccountImage = async (accountId: string) => {
    const handleImageLoaded = (image: string) => {
        if (image) {
            saveImageToCache(accountId, image);
            return;
        }
        removeImageFromCache(accountId);
    };

    if (isProductPapiCustomizationEnabled()) {
        getProductImage(accountId).then(handleImageLoaded);
        return;
    }

    getGeorgeByteImage(`my/accounts/${accountId}/images/image`, handleImageLoaded);
};

export const loadExternalAccountImage = (id: string): void => {
    getProductImage(id).then((image: string) => {
        if (image) {
            saveImageToCache(id, image);

            return;
        }

        removeImageFromCache(id);
    });
};
